import React from 'react';

import IProduct from '../../../../models/product';
import InputTextField from '../../../inputfields/InputTextField';
import InputLabel from 'components/inputfields/InputLabel';
import { isElectricLamp } from './category';
import { IFoodlaCategoryOption } from 'models/category';
import ThreeWaySwitch from 'components/inputfields/ThreeWaySwitch';

interface IDimensionsProps {
  approve?: boolean;
  state: IProduct;
  setState: (state: IProduct) => void;
  rootCategory?: IFoodlaCategoryOption;
  readOnly?: boolean;
}

export const Dimensions = ({ approve, state, setState, rootCategory, readOnly }: IDimensionsProps) => {
  // TODO any
  const handleChange = ({ target }: any) => setState({ ...state, [target.name]: target.value });

  return (
    <div style={{ width: '100%' }}>
      <InputLabel heading="Mått" />
      <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
        <div style={{ flex: 1, display: 'flex', gap: 4, alignItems: 'center', flexGrow: 1 }}>
          <InputTextField<IProduct>
            readOnly={readOnly}
            label="Mått"
            dense={false}
            inputName={'dimensions'}
            value={state.dimensions}
            hideComponentLabel={readOnly}
            onChange={handleChange}
          />
          {isElectricLamp(state.foodlaCategory, rootCategory) && <h3 style={{ margin: 0 }}>&nbsp;millimeter</h3>}
        </div>
        {approve && state?.approve?.find(x => x.field === 'dimensions') && (
          <ThreeWaySwitch
            readOnly={readOnly}
            state={state}
            setState={setState}
            name="dimensions"
          />
        )}
      </div>
    </div>
  );
};

export default Dimensions;
